<template>
    <div>
        <template-card-v2 :oneLog="oneLog" :linkedtype="linkedtype" :linkedid="linkedid">
            <template slot="icon">
                <CompassObject object="phone" size="small" />
            </template>
            <template slot="label"
                ><person-list-light
                    :list="[oneLog.staffs.params.list[0]]"
                    placeholderSingular="Collaborateur"
                    placeholderPlural="Collaborateurs"
                ></person-list-light
            ></template>

            <div slot="content">
                <div>
                    <div class="phone-call-main-information-container">
                        <div>
                            <div class="phone-call-card-date-container">
                                <CompassIcon size="small" icon="calendar-fill" />
                                <span class="typographies-paragraph-medium-semibold">
                                    {{ $t.__('common.labels.due_date', date) }}
                                </span>
                                <BadgeActivityStatus v-if="isLate" :tag="activityStatus" />
                            </div>
                            <CompassTag
                                v-if="oneLog.subject"
                                class="phone-call-card-tag"
                                type="dot"
                                size="small"
                                color="yellow"
                            >
                                {{ oneLog.subject }}
                            </CompassTag>
                            <div class="phone-call-card-container">
                                <div class="phone-call-card-title">
                                    <span class="typographies-paragraph-medium-semibold">
                                        {{ oneLog.label }}
                                    </span>
                                    <div
                                        class="typographies-paragraph-small-semibold phone-call-card-timer__container"
                                    >
                                        <span>{{ oneLog.status }}</span>
                                        <span v-if="oneLog.duration.length">- </span>
                                        <span
                                            v-if="oneLog.duration.length"
                                            class="typographies-paragraph-small-regular phone-call-card-timer__content-time"
                                        >
                                            <CompassIcon
                                                type="secondary"
                                                size="extra-small"
                                                icon="nav-timetracking"
                                                class="mx-1 gray-80"
                                            ></CompassIcon>
                                            {{ oneLog.duration }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="phone-call-card-buttons-container">
                            <TimelineActivityRescheduleButton
                                v-if="!oneLog.is_done"
                                :activity="activityForReschedule"
                            />
                            <ActivityUpdateStatusButton
                                v-if="shouldDisplayUpdateStatusButton"
                                :isDone="oneLog.is_done"
                                :pending="isUpdateStatusLoading"
                                :label="labelStatusButton"
                                statusButtonType="secondary"
                                @updateStatus="updateStatus"
                            />
                        </div>
                    </div>
                    <div
                        class="typographies-paragraph-medium-regular phone-call-card__content rich-text-style"
                        :class="editorClass"
                        v-html="addBrToEmptyPragraphs(oneLog.description)"
                    />
                </div>
            </div>
            <div slot="more"></div>
        </template-card-v2>
    </div>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';
import Feature from 'Services/Feature';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser } = createNamespacedHelpers('user');
import ActivityUpdateStatusButton from 'vcomponents/activities/ActivityUpdateStatusButton.vue';
import {
    markAsDoneWithNewForm,
    markAsTodoWithNewForm,
} from 'Helpers/activities/activitiesPhoneCallHelpers.js';
import BadgeActivityStatus from 'vcomponents/utilities/badge/BadgeActivityStatus.vue';
import TimelineActivityRescheduleButton from 'vcomponents/timeline/TimelineActivityRescheduleButton.vue';
import { addBrToEmptyPragraphs, editorClass } from 'Helpers/richTextHelper.js';

export default {
    components: {
        TimelineActivityRescheduleButton,
        TemplateCardV2,
        PersonListLight,
        ActivityUpdateStatusButton,
        BadgeActivityStatus,
    },
    mixins: [TimelineCardMixin],

    data() {
        return {
            lang: this.$parent.lang,
            isUpdateStatusLoading: false,
            activityForReschedule: {
                activityId: this.oneLog.objectid,
                type: this.oneLog.objecttype,
                date: moment.unix(this.oneLog.timestamp),
            },
        };
    },
    computed: {
        ...mapStateUser({
            userForename: 'forename',
            userName: 'name',
        }),
        editorClass,
        shouldDisplayUpdateStatusButton() {
            return (
                Feature.isEnabled('activity-listing-crm-follow-up-deal-priotization') &&
                Feature.isEnabled('activity-new-creation-panel')
            );
        },
        labelStatusButton() {
            return this.oneLog.is_done
                ? this.$t.__('timeline.PhoneCallCard.markAsTodo')
                : this.$t.__('timeline.PhoneCallCard.markAsDone');
        },
        isLate() {
            return moment().isAfter(moment.unix(this.oneLog.timestamp)) && !this.oneLog.is_done;
        },
        activityStatus() {
            return this.isLate ? { type: 'error', label: this.$t.__('common.labels.isLate') } : {};
        },
        date() {
            return this.$options.filters.dateFormatter(
                this.oneLog.timestamp,
                'NORMAL_DATE_TIME_WITH_DAY',
                false,
            );
        },
    },
    methods: {
        addBrToEmptyPragraphs,
        updateStatus() {
            if (!this.oneLog.is_done) {
                const date = moment.unix(this.oneLog.timestamp).toISOString();
                markAsDoneWithNewForm({
                    callback: () => {
                        EventBus.$emit('timeline:refreshLog', 'phonecall', this.oneLog.objectid);
                    },
                    id: +this.oneLog.objectid,
                    date,
                    description: this.oneLog.description,
                });
            } else {
                this.isUpdateStatusLoading = true;
                markAsTodoWithNewForm({ id: +this.oneLog.objectid })
                    .then(() => {
                        EventBus.$emit('timeline:refreshLog', 'phonecall', this.oneLog.objectid);
                    })
                    .finally(() => {
                        this.isUpdateStatusLoading = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.phone-call-card {
    &-timer {
        &__container {
            display: flex;
            line-height: 16px;
            border: solid var(--colors-common-border-lighter) 1px;
            border-radius: 20px;
            width: max-content;
            padding: 2px var(--spacing-1);
            gap: var(--spacing-0);
            span {
                color: var(--colors-common-text-subtle-default);
            }
        }
        &__content-time {
            display: flex;
            align-items: center;
        }
    }
    &-container {
        display: flex;
        gap: var(--spacing-1);
        align-items: center;
    }
    &-title {
        display: flex;
        gap: var(--spacing-1);
    }
    &-tag {
        margin-bottom: var(--spacing-1);
    }
    &__content {
        margin: var(--spacing-0) 0 0;
    }
}
.phone-call-main-information-container {
    display: flex;
    gap: var(--spacing-1);
    justify-content: space-between;
    align-items: flex-start;

    .phone-call-card-buttons-container {
        display: flex;
        gap: var(--spacing-3);
    }

    .phone-call-card-date-container {
        display: flex;
        gap: var(--spacing-0);
        align-items: center;
    }
}
</style>
